const PipsTradeAppContentTwo = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Real-Time Market Access</h4>
              </div>
              <p>
                Stay connected to live prices across Forex, Commodities, Stocks,
                and Cryptocurrencies. The app delivers accurate data and fast
                order execution for a true market edge.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Interactive Charts & Indicators</h4>
              </div>
              <p>No hidden charges, what you see is what you trade.</p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Secure & Seamless Transactions</h4>
              </div>
              <p>
                Our multilingual support team is ready to assist you anytime.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Smart Notifications & Alerts</h4>
              </div>
              <p>
                Get notified about market shifts, trade executions, and account
                changes instantly, so you’re always in control, even when you’re
                on the move.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PipsTradeAppContentTwo;
